export default function Hero() {
  return (
    <section
      id="hero"
      className="relative pt-16 md:pt-18 min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-full md:w-3/5 h-full opacity-[0.12]"
        style={{
          backgroundImage: 'radial-gradient(circle at 70% 50%, oklch(var(--primary-400) / 0.3) 0%, transparent 60%)',
        }}
      ></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-4 md:mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              <span>实时追踪 · 每日更新</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight tracking-tight">
              网红黑料
              <span className="block text-primary-600">一站吃尽网红圈黑料情报</span>
            </h1>

            <p className="mt-4 md:mt-5 text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              每日汇总网红圈最新黑料、爆料与吃瓜情报，实时追踪直播翻车、人设崩塌、虚假宣传、抄袭实锤等热门事件。无论是最新网红黑料、圈内互撕还是MCN内幕，这里都有你想要的真相。全新情报页面每日滚动更新，让你不错过任何一个瓜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-5 md:mt-6 text-xs md:text-sm text-foreground-500">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-eye-line text-accent-500"></i>
                日均访问 580万+
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-article-line text-accent-500"></i>
                收录情报 12.6万条
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-time-line text-accent-500"></i>
                7x24小时滚动更新
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6 md:mt-8">
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm px-6 py-3 rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                查看今日热榜
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-foreground-300 text-foreground-700 hover:text-primary-600 hover:border-primary-300 font-medium text-sm px-6 py-3 rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                我要爆料投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20editorial%20scene%20with%20shattered%20smartphone%20screen%20displaying%20social%20media%20icons%20breaking%20apart%2C%20warm%20amber%20and%20deep%20crimson%20mood%20lighting%2C%20contrast%20between%20glamorous%20social%20media%20facade%20and%20hidden%20truth%20revealed%2C%20investigative%20journalism%20aesthetic%2C%20cinematic%20dramatic%20composition%20with%20broken%20glass%20effect&width=700&height=550&seq=hero-main-2026&orientation=landscape"
                alt="网红黑料情报站 - 揭秘网红圈黑料与最新爆料"
                className="relative w-full h-auto rounded-xl object-cover"
                width="700"
                height="550"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}